export default __webpack_public_path__ + "155519ba5487605b6d08c6e520a313ad.png";